import React, { useState } from 'react'
import { Binoculars, X } from '@phosphor-icons/react'

const ProjectContentsSearch = ({ project_path, onSearchResults }) => {
  const [search, setSearch] = useState('')

  const fetchContents = async (query = '') => {
    const url = query ? `${project_path}?query=${query}` : project_path
    const response = await fetch(url, {
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').
          getAttribute('content'),
        'Accept': 'application/json',
      },
    })

    if (response.ok) {
      const contents = await response.json()
      onSearchResults(contents)
    }
  }

  const handleSearch = async () => {
    await fetchContents(search)
  }

  const resetSearch = async () => {
    setSearch('')
    await fetchContents()
  }

  return (
    <div className="flex flex-row gap-4 items-center justify-center">
      <input
        onKeyDown={(e) => {
          if (e.key === 'Enter' && search.length >= 3) {
            handleSearch()
          }
        }}
        type="text"
        placeholder="Search"
        className={`input input-bordered w-full ${search.length >= 3
          ? 'input-primary'
          : ''}`}
        value={search}
        onChange={(e) => setSearch(e.target.value)}>
      </input>
      <button
        disabled={search.length <= 3}
        className="btn btn-secondary"
        onClick={handleSearch}
      >
        <Binoculars weight="fill" color="white" size={24}/>
      </button>
      <button
        disabled={search.length <= 3}
        className="btn btn-secondary"
        onClick={resetSearch}
      >
        <X weight="fill" color="white" size={24}/>
      </button>
    </div>
  )
}

export default ProjectContentsSearch